import { useCallback, useState } from 'react';

/**
 * Hook to manage the third-party connector setup modal state.
 *
 * Returns `openSetupModal` to set the active connector key,
 * `activeConnectorKey` to determine which connector modal to show,
 * and `closeModal` to dismiss it. The actual modal rendering is handled
 * by the surface component (e.g. ConnectorPromoSidebar) using SetupConnectorModal.
 */
export function useSetupConnector(): {
	openSetupModal: (connectorKey: string) => void;
	activeConnectorKey: string | null;
	closeModal: () => void;
} {
	const [activeConnectorKey, setActiveConnectorKey] = useState<string | null>(null);

	const openSetupModal = useCallback((connectorKey: string): void => {
		setActiveConnectorKey(connectorKey);
	}, []);

	const closeModal = useCallback((): void => {
		setActiveConnectorKey(null);
	}, []);

	return { openSetupModal, activeConnectorKey, closeModal };
}
